import { type FC } from "react";
import classNames from "classnames";

import { IconSize } from "~/common/mui/icons/IconSize";
import { PopperTooltip } from "~/common/components/Tooltip";
import { useTranslation } from "react-i18next";
import { URL_PREFERRED_PRODUCTS } from "~/utils/url/staticUrls";
import { ArrowLink } from "~/common/components/Link";
import { userIsCustomer } from "~/domains/user/utils/roles";
import StarIcon from "@mui/icons-material/Star";
import { styled } from "~/common/mui";

interface ProductPreferredIndicatorProps {
  className?: string;
  side?: "left" | "right" | "bottom";
  iconSize?: IconSize;
}

const iconSizeToFontSize = (iconSize?: IconSize): number => {
  switch (iconSize) {
    case IconSize.FONT_10:
      return 10;
    case IconSize.FONT_20:
      return 20;
    case IconSize.FONT_24:
      return 24;
    case IconSize.FONT_30:
      return 30;
    case IconSize.FONT_50:
      return 50;
    case IconSize.FONT_64:
      return 64;
    case IconSize.FONT_16:
    default:
      return 16;
  }
};

const ProductPreferredIndicator: FC<ProductPreferredIndicatorProps> = (props) => {
  const { className, side = "left", iconSize } = props;
  const isCustomer = userIsCustomer();

  const { t } = useTranslation();

  return (
    <PreferredIndicatorTooltip
      className={classNames("scha__preferred__popup", className)}
      innerClassName={"scha__preferred__popup__inner"}
      tooltipContent={
        isCustomer ? (
          <ArrowLink className={"f-no-wrap"} href={URL_PREFERRED_PRODUCTS}>
            {t("product.isPreferred")}
          </ArrowLink>
        ) : (
          t("product.isPreferred")
        )
      }
      placement={side}
    >
      <StarIcon
        className="f-green"
        sx={{ fontSize: iconSizeToFontSize(iconSize) }}
        data-test-id={"product-is-preferred"}
      />
    </PreferredIndicatorTooltip>
  );
};

const PreferredIndicatorTooltip = styled(PopperTooltip)({
  "& .scha__preferred__popup__inner": {
    display: "flex",
  },
});

export default ProductPreferredIndicator;
